import { MSidebar } from '@fruition/design-system'
import { type MouseEvent, useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import type { Props } from './Sidebar.types'

export const Sidebar = ({
  items,
  label,
  onCreateButtonClick,
  onItemClick,
  showCreateButton,
  showBackButton,
  onBackButtonClick,
  labelBadge,
}: Props) => {
  const location = useLocation()
  const navigate = useNavigate()
  const [, basePath, pathKey, subPathKey] = location.pathname.split('/')
  const [selected, setSelected] = useState(items[0]?.key)

  const handleItemClick = (_: MouseEvent<HTMLButtonElement>, key: string) => {
    setSelected(key)
    navigate(`/${basePath}/${key}`)
    onItemClick?.(_, key)
  }

  useEffect(() => {
    const firstItem = items[0]
    const selectedPath =
      subPathKey && pathKey && subPathKey === 'investment'
        ? `${pathKey}/${subPathKey}`
        : pathKey
          ? pathKey
          : (items.find((item) => item.key === '')?.key ?? firstItem?.key)
    setSelected(selectedPath)
  }, [items, pathKey, subPathKey])

  return (
    <MSidebar
      showBackButton={showBackButton}
      onBackButtonClick={onBackButtonClick}
      label={label}
      items={items}
      onItemClick={handleItemClick}
      selected={selected}
      onCreateButtonClick={onCreateButtonClick}
      showCreateButton={showCreateButton}
      sx={{
        position: 'sticky',
        width: '318px',
      }}
      labelBadge={labelBadge}
    />
  )
}
